
export const thingsToDoArr = [
    
]

export const TouristInfoPosts = [

    
    {
        "title": "VERKEHRSMITTEL",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/transportation.jpg",
        "side_img": "/PostCarousel/transportation.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Transport",
        "ctg": "TouristInfo",
        "isVid": false,
        "id": "Transport"
    },
    {
        "title": "REISEPASS UND VISUM",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Passports-visa.jpg",
        "side_img": "/PostCarousel/Passports-visa.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Passport_Visa",
        "ctg": "TouristInfo",
        "isVid": false,
        "id": "Passport_Visa"
    },
    {
        "title": "WAS SOLLTEN SIE EINPACKEN?",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/what-to-pack.jpg",
        "side_img": "/PostCarousel/what-to-pack.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=What_To_Pack",
        "ctg": "TouristInfo",
        "isVid": false,
        "id": "What_To_Pack"
    },
    {
        "title": "ELEKTRISCHE GERÄTE",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/electrical-appliances.jpg",
        "side_img": "PostCarousel/electrical-appliances.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Electrical_Appliances",
        "ctg": "TouristInfo",
        "isVid": false,
        "id": "Electrical_Appliances"
    },
    {
        "title": "FAQ",
        // "sml_desc": "Welche papiere/visa benötige ich zur einreise nach Israel?",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/faq.jpg",
        "side_img": "PostCarousel/faq.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=F_A_Q",
        "ctg": "TouristInfo",
        "isVid": false,
        "id": "F_A_Q"
    },
    {
         "title":"EIN REISEZIEL FÜR JEDEN GESCHMACK",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
         "side_img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-Passports-visa",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Destination_For_All'
    },
    
]

export const newVideos = [


    {
        "title" : "Abenteuer im Freien",
        // "sml_desc": "Tel Aviv im Sattel",
        "sml_desc": "",
        // "desc": "Eine actionreiche Stadt, die\n perfekt für aktive Menschen ist",
        "desc": "",
        "img": "Videos/12.jpg",
        "img_mob":"/Videos/video_mob/12.jpg",
        "side_img": "Videos/sidebar/12.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=20",
        "vidId": "88OV6xU0vPI",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": true,
        "id": 20
    },
    {
        "title": "Auf der Suche nach dem ultimativen Nachtleben?",
        // "sml_desc": " Book your trip to Tel Aviv!",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/crazy-night.jpg",
        "img_mob":"/Videos/video_mob/crazy-night.jpg",
        "side_img": "Videos/sidebar/crazy-night.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Crazy_Night",
        "vidId": "ogEN7aRT0SM",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": true,
        "id": 9
    },

    {
        "title": "JERUSALEM",
        // "sml_desc": "THE HEART OF THE WORLD",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/heart-of-the-world.jpg",
        "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
        "side_img": "Videos/sidebar/heart-of-the-world.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Heart_Of_The_World",
        "vidId": "nLKWDp5uA-U",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": 10
    },

    {
        "title": "Modern und lebendig",
        // "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
        "desc": "",
        "sml_desc": "",
        "img": "Videos/c.jpg",
        "img_mob":"/Videos/video_mob/c.jpg",
        "side_img": "Videos/sidebar/c.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=19",
        "vidId": "TeLJmRatQeM",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": 9
    },
    {
        "title": "DAS TOTE MEER",
        // "sml_desc": "Zeit für eine Auszeit in \n der glorreichen Natur",
        // "desc": "Höchster Genuss am \n tiefstgelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/f.jpg",
        "img_mob":"/Videos/video_mob/f.jpg",
        "side_img": "Videos/sidebar/f.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=2",
        "vidId": "ixFocykfYHo",
        "ctg": "deadsea",
        "forVidPage": true,
        "isVid": true,
        "id": 14
    },

    {
        "title": "Hafenfreuden",
        // "sml_desc": "Die häfen von Tel Aviv",
        // "desc": "Die verschiedenen Reize von \nTel Aviv und Jaffa Häfen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/3.jpg",
        "img_mob":"/PostCarousel/video_mob/3.jpg",
        "side_img": "/PostCarousel/3.jpg",
        "read_more": "Weiterlesen",
        "vidId": "iHqD5eHDZm8",
        "link": "/Posts/index.php?post=3",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 3
    },

  

    {
        "title": "DAS TOTE MEER",
        // "sml_desc": "Zeit für eine Auszeit in\nder glorreichen Natur",
        // "desc": "Höchster Genuss am \ntiefstgelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/100.jpg",
        "img_mob":"/PostCarousel/video_mob/100.jpg",
        "side_img": "/PostCarousel/100.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=2",
        "vidId": "ixFocykfYHo",
        "css_class": "unic_video-post-3",
        "isVid": true,
        "forVidPage": true,
        id: 3,
        ctg: "deadsea"
    },


    {
        "title": "Sarona Tel Aviv",
        // "desc": "Eine riesige Auswahl von Attraktionen in \n der überwältigenden sanierten Templerkolonie",
        // "sml_desc": "Eine atemberaubende urbane Oase",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=1",
        "vidId": "7JF0z2XPpz0",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 7
    },

    {
        "title": "Die Altstadt",
        // "sml_desc": "Spüre, wie die Geschichte \n zum Leben erwacht",
        // "desc": "Lassen Sie sich von den weltberühmten Schätzen \n des historischen Jerusalem inspirieren",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/m.jpg",
        "img_mob":"/Videos/video_mob/m.jpg",
        "side_img": "Videos/sidebar/m.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=4",
        "vidId": "1byfX1O7u4g",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": 13
    },

    {
        "title": "Neve Tzedek",
        // "sml_desc": "Schick und einzigartig",
        // "desc": "Liebenswerte Cafés, Boutiquen, Kunstgalerien, \n Eleganz und coole Vibes",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/j.jpg",
        "img_mob":"/Videos/video_mob/j.jpg",
        "side_img": "Videos/sidebar/j.jpg",
        "read_more": "Weiterlesen",
        "vidId": "-ESCEVfOreY",
        "link": "/Posts/index.php?postType=video&post=7",
        "css_class": "unic_video-post-13",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 8
    },


    
    


    {
        "title": "Tel Aviv Am Srand",
        // "sml_desc": "Weil sich das Leben in Tel Aviv \n von der Sonnenseite zeigt",
        // "desc": "Bereit für eine volle \nLadung Spaß in der Sonne?",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob": "Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        "vidId": "ExuWHatIrKE",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 4
    },




    {
        "title": "Die Stra Die Strande Von Tel Aviv",
        // "sml_desc": "Entspannen Sie Sich An Den\n Sonnigen Stranden Von Tel Aviv",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/14.jpg",
        "side_img": "/PostCarousel/14.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=14",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": 14
    },



    {
        "title": "Tel Aviv",
        // "sml_desc": "Mit dem Fahrrad in Tel Aviv",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=38",
        "ctg": "telaviv",
        "vidId": "88OV6xU0vPI",
        "forVidPage": true,
        "isVid": true,
        "id": 39
    },

    
     {
        "title": "Absolutes Muss in Tel Aviv",
        // "sml_desc": "Top 5 Stätten, die Sie in der Nonstop-Stadt nicht verpassen wollen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/17.jpg",
        "side_img": "/PostCarousel/17.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=17",
        "ctg": "telaviv",
        "vidId": "LLOUxE-K_9Y",
        "isVid": true,
        "forVidPage": true,
        "id": 17
    },



    {
        "title": "Absolutes \'Muss\' in Jerusalem",
        // "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=18",
        "vidId":"k4OwoEk5wMw",
        "isVid": true,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": 18
    },
   
    {
        "title": "Modern und lebendig",
        // "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/19.jpg",
        "side_img": "/PostCarousel/19.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=19",
        "vidId": "MXtcTm_JXus",
        "isVid": true,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": 19
    },

    {
        "title": "Einkaufsfreuden",
        // "sml_desc": "Von Couture bis zu Souvenirs, Jerusalem hat alles",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=5",
        "ctg": "jerusalem",
        "vidId": "MXtcTm_JXus",
        "isVid": true,
        "forVidPage": true,
        "id": 5
     },
    

    {
        "title": "Das Spirituelle Jerusalem",
        // "sml_desc": "Die Wichtigsten Sehenswurdigkeiten In Jerusalem",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/9.jpg",
        "side_img": "/PostCarousel/9.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=9",
        "isVid": true,
        "forVidPage": true,
        "vidId":"k4OwoEk5wMw",
        "ctg": "jerusalem",
        "id": 99
    },

    
    {
        "title": "DIE WÜSTE NEGEV",
        // "sml_desc": "ein zauberhafter Ort",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/16.jpg",
        "side_img": "/PostCarousel/16.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=16",
        "isVid": true,
        "forVidPage": true,
        "vidId":"yXzhH92kREg",
        "ctg": "eilat",
        "id": "Die_Wuste_Negev"
    },
 
    {
        "title": "ERKUNDEN SIE MASADA",
        // "sml_desc": "Mythos im Herzen der Judäischen Wüste",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/masada.jpg",
        "side_img": "/PostCarousel/masada.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Masada",
        "ctg": "eilat-negev",
        "isVid": true,
        "forVidPage": true,
        "vidId":"i8IjojQ39u0",
        "id": "Masada"
    },

    {
        "title": "NAZARETH",
        // "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
        "sml_desc":  "",
        "desc": "",
        "img": "/PostCarousel/nazareth.jpg",
        "side_img": "/PostCarousel/nazareth.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Nazareth",
        "ctg": "north",
        "isVid": true,
        "forVidPage": true,
        "vidId":"aGMVTrHS8YA",
        "id": "Nazareth"
    },


    {
        "title": "JERUSALEM ENTDECKEN",
        // "sml_desc": "Entdecken Sie die Geheimnisse des jüdischen Jerusalem in der geschichtsträchtigen Altstadt",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/discover-jerusalem.jpg",
        "side_img": "PostCarousel/discover-jerusalem.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Discover_Jerusalem",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "vidId":"1byfX1O7u4g",
        "id": "Discover_Jerusalem"
    },

    {
        "title": "WAGEN SIE EINEN SPRUNG",
        // "sml_desc": "Erleben Sie die Wasserattraktionen in Eilat",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/atractions-in-eilat.jpg",
        "side_img": "PostCarousel/atractions-in-eilat.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Atractions_In_Eilat",
        "ctg": "eilat-negev",
        "isVid": true,
        "forVidPage": true,
        "vidId":"wTR-9PxXn-E",
        "id": "Atractions_In_Eilat"
    },

    {
        "title": "DAS DOLPHIN REEF EILAT",
        // "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/the-dolphin-reef.jpg",
        "side_img": "PostCarousel/the-dolphin-reef.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Dolphin_Reef",
        "ctg": "eilat-negev",
        "isVid": true,
        "forVidPage": true,
        "vidId":"HzBX-XW9T0c",
        "id": "The_Dolphin_Reef"
    },
    
    {
        "title": "HAIFA BERAUSCHENDE SCHÖNHEIT",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/haifa-intoxicating-beauty.jpg",
        "side_img": "/PostCarousel/haifa-intoxicating-beauty.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Haifa_Intoxicating_Beauty",
        "ctg": "north",
        "isVid": true,
        "forVidPage": true,
        "vidId":"7_156GUZMF4",
        "id": "Haifa_Intoxicating_Beauty"
    },

    {
        "title": "The Hula Valley Natural",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/the-hula-valley-natural.jpg",
        "side_img": "/PostCarousel/the-hula-valley-natural.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Hula_Valley_Natural",
        "ctg": "north",
        "isVid": true,
        "forVidPage": true,
        "vidId":"h5TV5VwQeWY",
        "id": "The_Hula_Valley_Natural"
    },


    {
        "title": "DAS TOTE MEER",
        // "sml_desc": "Aufschwung für Geist und Seele am tiefst gelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/aufschwung-fur-geist.jpg",
        "side_img": "/PostCarousel/aufschwung-fur-geist.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Aufschwung_Fur_Geist",
        "ctg": "deadsea_2",
        "isVid": true,
        "forVidPage": true,
        "vidId":"KijyxSgDpuY",
        "id": "Aufschwung_Fur_Geist"
    },

   
    {
        "title": "TIMNA PARK",
        // "sml_desc": "Ein begeisterndes Wüstenabenteuer",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/park-timna.jpg",
        "side_img": "/PostCarousel/park-timna.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Park_Timna",
        "ctg": "eilat-negev",
        "isVid": true,
        "forVidPage": true,
        "vidId":"Id0U0OeDs7Y",
        "id": "Park_Timna"
    },
    

    {
        "title": "SAFED",
        // "sml_desc": "wo Mystik und Weltliches aufeinandertreffen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/mystic-and-worldly-meeting.jpg",
        "side_img": "/PostCarousel/mystic-and-worldly-meeting.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Mystic_And_Worldly_Meeting",
        "ctg": "north",
        "isVid": true,
        "forVidPage": true,
        "vidId":"i3_ihL51bHo",
        "id": "Mystic_And_Worldly_Meeting"
    },
    
    // THESE THREE posts complite the missing posts for carousel THINGS TO DO
    {
        "title": "Absolutes \'Muss\' in Jerusalem",
        // "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=18",
        "vidId":"k4OwoEk5wMw",
        "isVid": true,
        "forVidPage": true,
        "isDouble": true,
        "ctg": "jerusalem",
        "id": 18
    },
    {
        "title": "NAZARETH",
        // "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
        "sml_desc":  "",
        "desc": "",
        "img": "/PostCarousel/nazareth.jpg",
        "side_img": "/PostCarousel/nazareth.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Nazareth",
        "ctg": "north",
        "isVid": true,
        "forVidPage": true,
        "isDouble": true,
        "vidId":"aGMVTrHS8YA",
        "id": "Nazareth"
    },
    {
        "title": "DAS DOLPHIN REEF EILAT",
        // "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/the-dolphin-reef.jpg",
        "side_img": "PostCarousel/the-dolphin-reef.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Dolphin_Reef",
        "ctg": "eilat-negev",
        "isVid": true,
        "forVidPage": true,
        "isDouble": true,
        "vidId":"HzBX-XW9T0c",
        "id": "The_Dolphin_Reef"
    },
    // End THESE THREE posts complite the missing posts for carousel THINGS TO DO
 


]

// start showsArr

// export const showsArr = [


//       {
//         title: "Pride Week 2020",
//         desc: "",
//         date: "12.06.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Week_2020",
//         css_class: "unic-singer-Pride_Parade_2020",
//         id: "Pride_Week_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "White Night",
//         desc: "",
//         date: "06.2020",
//         img:"Concerts/53.jpg",
//         side_img:"Concerts/53.jpg",
//         link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//         css_class: "unic-singer-white-night-2020",
//         id: "White_Night_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.2020",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: "",
//         css_class: "unic-singer-nickcave-badseeds",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "The Pixies",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "unic-singer-pixies-2020",
//         id: "The_Pixies_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.2020",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
        
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Hutzot Hayotzer Jerusalem",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020", 
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "",
//         date: "08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-openhf-2020",
//         id: "Open_Houses_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Der Jerusalem-Marsch",
//         desc: "",
//         date: "03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-jerusalem-march-2020",
//         id: "The_Jerusalem_March_2020",
//         book_now : "READ MORE"
//       },
     
      
     

//       /*----------------OLD SINGERS------------------*/

//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "unic-singer-13",
//         id:44,
//         book_now: "Weiterlesen"
//       },


//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Weiterlesen"
//       },
      
//       {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//        img  : "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "unic-singer-3",
//        id:29,
//        book_now : "Weiterlesen"
//       },

//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "unic-singer-4",
//         id:17,
//         book_now: "Weiterlesen"
//       },

//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        img  : "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "unic-singer-2",
//        id:36,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//        img  : "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Weiterlesen"
//       },

//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//        img  : "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        img  : "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//        img  : "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//        img  : "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//        img  : "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//        img  : "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Weiterlesen"
//       },

//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Weiterlesen"
//       },

//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "3.08.2017",
//        img  : "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "7-23.08.2017",
//        img  : "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//        img  : "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Weiterlesen"
//       },

//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//        img  : "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Weiterlesen"
//       },

//         {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-daddyyanke",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-tomjones",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-paul",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-seanpaul",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-ozuna",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-balvin",
//         book_now : "Weiterlesen"
//       },

       
//        {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "unic-singer-68",
//         id:68,
//         book_now : "Weiterlesen"
//       },
      
//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-76",
//         id: 76,
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "unic-singer-69",
//         id:69,
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "Weiterlesen"
//       },
     
      
//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "unic-singer-lionel-richie",
//         book_now : "Weiterlesen"
//       },
      
//       {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "Weiterlesen"
//       },
      

      

//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "unic-singer-jim-jeffries",
//         book_now : "Weiterlesen"
//       },

//       // {
//       //   title: "Open Restaurants TLV",
//       //   desc: " Feed Your Curiosity!",
//       //   date: "2019",
//       //   img:"Concerts/openRestTlv.jpg",
//       //   side_img:"Concerts/openRestTlv.jpg",
//       //   link: "/Posts/index.php?postType=concerts&post=70",
//       //   css_class: "unic-singer-70",
//       //   id:70,
//       //   book_now : "Weiterlesen"
//       // },
//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img:"Concerts/openRestTlv.jpg",
//         side_img:"Concerts/openRestTlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:70,
//         book_now : "Weiterlesen"
//       },

//       {
//         title: "Tel Aviv Marathon",
//         desc: "",
//         date: "28.02.2020",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Purim 2020",
//         desc: "",
//         date: "09-10.03.20",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "unic-purim2020",
//         id: "Purim_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Tel Aviv Fashion Week",
//         desc: "",
//         date: "03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "unic-fashion-week-2020",
//         id: "TelAviv_Fashion_Week_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.2020",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "unic-singer-jer-marathon2019",
//         id: "Jerusalem_Marathon",
//         book_now : "READ MORE"
//       },

// ];

// End showsArr

export const showsArr = [];


export const faqData  = [ 
   {  
      id : 1 ,
      q : "Häufig gestellte Fragen (FAQ)",
      answer : `
      <ol start="1">
        <li>
                <strong>Ich bin als Tourist in Israel und bin besorgt, dass ich COVID-19 haben könnte, an wen wende ich mich?</strong><br/>
                Wenn Sie 38 °C Fieber oder höher, Husten, Atembeschwerden oder andere Atemwegssymptome haben, müssen Sie sich sofort in Quarantäne begeben und die Notfall-Hotline 101 anrufen, um medizinischen Rat zu erhalten.<strong className="ac-pink">Gehen Sie auf keinen Fall in eine HMO-Klinik oder eine Notfallstation.</strong>
              </li>
              <li>
                <strong>Wann wird Israel wieder für Besucher von außerhalb zugänglich sein?</strong><br/>
                Zum gegenwärtigen Zeitpunkt ist kein Datum bekannt, an dem Israel für Besucher von außerhalb zugänglich sein wird.
              </li>
       
      </ol>
      `,
      isOpen : false
   },
   {  
      id : 2 ,
      q : "DAUERT DIE REISE NACH TEL AVIV UND JERUSALEM LANGE?  ",
      answer : `
      <p>
        Im Gegenteil! Es geht schneller als Sie denken: Nach gerade einmal 4-5 Stunden Flugzeit können Sie die sonnigen Strände Tel Avivs und beeindruckenden Sehenswürdigkeiten Jerusalems genießen. Und das Beste daran: Tel Aviv und Jerusalem sind nur eine Autostunde voneinander entfernt.
      </p>
      `,
      isOpen : false
   },

   {  
      id : 3 ,
      q : "WIE KOMME ICH IN TEL AVIV UND JERUSALEM VON A NACH B?",
      answer : `
      
      <p>
       Die bequemsten und beliebtesten Verkehrsmittel sind Busse, Sammeltaxis und die staatliche Bahn. Jerusalem verfügt darüber hinaus über eine komfortable Stadtbahn mit Haltestellen an vielen beliebten Orten der Stadt.
      </p>
      <p>
       Informationen zu Bahnhöfen, Routen und Fahrplänen besuchen Sie <a target="_blank" href="//www.rail.co.il">www.rail.co.il</a>
      </p>
      <p>
       Informationen zu Buslinien und Fahrplänen finden Sie unter <a target="_blank" href="//www.bus.gov.il">www.bus.gov.il</a>  
      </p>
      <p>
       Hotline für öffentliche Verkehrsmittel <a href="tel:*8787">*8787</a>  
      </p>
      <p>
       App für den öffentlichen Nahverkehr -'Moovit'. 
      </p>
      <h4>
      Taxis 
      </h4>
      <p>
        Taxis für Stadt- und Überlandfahrten können Sie auf der Straße heranwinken oder telefonisch beziehungsweise über Apps wie Gett (GetTaxi) rufen.
      </p>

      <h4>
      Sherut Taxis 
      </h4>
      <p>
         "Sherut" (Sammel)Taxis sind 10- bis 12-sitzige Kleinbusse, die in der Regel auf den Strecken der wichtigen Buslinien verkehren, innerstädtisch ebenso wie zwischen Großstädten. Sherut Taxis bieten, ähnlich der öffentlichen Buslinien einen Festpreis an.
      </p>

      <h4>
         Mietwagen 
      </h4>
      <p>
        Die meisten Autovermietungen im Stadtgebiet von Tel Aviv finden sich entlang der Hayarkon Street sowie in Strandnähe. In den meisten anderen Großstädte sind sie in der Nähe der Hotels zu finden .
      </p>

      <h4>
      Tel-O-Fun 
      </h4>
      <p>
        Tel-O-Fun ist ein Fahrrad-Sharing-Service der Stadt Tel Aviv, der für Einwohner und Besucher der Stadt angeboten wird. Tel-O-Fun verfügt über 2.000 Fahrräder an 200 Stationen an denen Sie ein Rad mieten können, um die 130 Kilometer ausgewiesener Radwege zu erkunden. Mit Ihrer Kreditkarte können Sie eine Tages- oder Wochenkarte an den Terminals der Vermietstationen erwerben.
      </p>
      .
      `,
      isOpen : false,
   },
   

   {  
      id : 4 ,
      q : "WIE BEZAHLE ICH IN ISRAEL? ",
      answer : `
      <p>
        Die israelische Währung ist der Schekel. Bargeld können Sie an Geldautomaten bei Banken in der ganzen Stadt abheben. An Kiosken gibt es darüber hinaus private Geldautomaten, die eine Provision von 5,90-7,90 NIS pro Auszahlung berechnen. Möglichkeiten Geld zu wechseln finden Sie in privaten, provisionsfreien Wechselstuben in touristischen Gebieten, die in der Regel bis spät abends geöffnet haben. Natürlich werden allerorten auch Kreditkarten akzeptiert. Und für Geldtransfers bietet in den meisten Postämtern Western Union seine Dienste an. 
      </p>
      `,
      isOpen : false,
   },
   

   {  
      id : 5 ,
      q : "IN VERBINDUNG BLEIBEN",
      answer : `

        <h4>
          Mobiltelefone nutzen
        </h4>
        <p>
          Falls gewünscht, können Sie in Telefonläden oder bei den Informationszentren der Stadt eine lokale SIM-Karte erwerben. Viele kleine Geschäfte und Wechselstuben bieten auch Prepaid-Karten zum Verkauf an.
        </p>

        <h4>
          Hotspots – Kostenloses W-LAN
        </h4>
        <p>
         Tel Aviv ist eine zukunftsweisende, smarte Stadt – und sehr stolz darauf. Kostenloses W-LAN steht Ihnen an 80 verschiedenen Orten im Stadtgebiet zur Verfügung (einschließlich dem Strand, den Ausgehvierteln und den meisten touristischen Stadtbereichen).
        </p>
        <p>
          Jerusalem bietet kostenloses Wi-Fi an Bahnhöfen, in Universitäten, Museen, Besucherzentren, Kongresshallen, Tourismus- und Einkaufszentren sowie im lokalen Besucherinformationszentrum.
        </p>

      `,
      isOpen : false,
   },
   

   {  
      id : 6 ,
      q : "WIE IST DAS WETTER?",
      answer : `
        <p>
        Das Wetter in Tel Aviv ist das ganze Jahr über schön und angenehm. Der Sommer ist lang und bietet sich für Tage am Strand und Erkundungstouren an, der Winter ist freundlich und ohne nennenswerte Niederschläge. Durchschnittstemperaturen im Winter 9-17 °C, im Sommer 24-30 °C.
        </p>
        <p>
          In Jerusalem erfreut man sich langer sonniger Sommer (Mai-September), hat aber auch teils kalte und regnerische Winter (November-März) mit gelegentlichen Schneestürmen und Temperaturen um den Gefrierpunkt. Aktuelle Wetterinformationen finden Sie auf der Website des Israelischen Meteorologischen Dienstes unter <a target="_blank" href="//www.ims.gov.il">www.ims.gov.il</a>

        </p>
      `,
      isOpen : false,
   },

   {  
      id : 7 ,
      q : "SIND DIE ARBEITSZEITEN ANDERS? ",
      answer : `
        
        <p>
           Ja, die Werktage sind Sonntag bis Donnerstag, während an Freitagen und Samstagen Wochenende ist. Die meisten Geschäfte haben freitags bis zum frühen Nachmittag geöffnet – im Einklang mit dem jüdischen Sabbat, der von Freitag bei Sonnenuntergang bis Samstag kurz nach Sonnenuntergang dauert. Weitere Informationen finden Sie unter <a target="_blank" href="//www.timeanddate.com/worldclock/Israel">www.timeanddate.com/worldclock/Israel</a>
        </p>
      `,
      isOpen : false,
   },
   
]



export const newPosts = [


    // videos

    {
        "title" : "Abenteuer im Freien",
        // "sml_desc": "Tel Aviv im Sattel",
        "sml_desc": "",
        // "desc": "Eine actionreiche Stadt, die\n perfekt für aktive Menschen ist",
        "desc": "",
        "img": "Videos/12.jpg",
        "img_mob":"/Videos/video_mob/12.jpg",
        "side_img": "Videos/sidebar/12.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=20",
        "vidId": "88OV6xU0vPI",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": true,
        "id": 20
    },
    {
        "title": "Auf der Suche nach dem ultimativen Nachtleben?",
        // "sml_desc": " Book your trip to Tel Aviv!",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/crazy-night.jpg",
        "img_mob":"/Videos/video_mob/crazy-night.jpg",
        "side_img": "Videos/sidebar/crazy-night.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Crazy_Night",
        "vidId": "ogEN7aRT0SM",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": true,
        "id": 9
    },

    {
        "title": "JERUSALEM",
        // "sml_desc": "THE HEART OF THE WORLD",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/heart-of-the-world.jpg",
        "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
        "side_img": "Videos/sidebar/heart-of-the-world.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Heart_Of_The_World",
        "vidId": "nLKWDp5uA-U",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": 10
    },

    {
        "title": "Modern und lebendig",
        // "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
        "desc": "",
        "sml_desc": "",
        "img": "Videos/c.jpg",
        "img_mob":"/Videos/video_mob/c.jpg",
        "side_img": "Videos/sidebar/c.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=19",
        "vidId": "TeLJmRatQeM",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": 9
    },
    {
        "title": "DAS TOTE MEER",
        // "sml_desc": "Zeit für eine Auszeit in \n der glorreichen Natur",
        // "desc": "Höchster Genuss am \n tiefstgelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/f.jpg",
        "img_mob":"/Videos/video_mob/f.jpg",
        "side_img": "Videos/sidebar/f.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=2",
        "vidId": "ixFocykfYHo",
        "ctg": "deadsea",
        "forVidPage": true,
        "isVid": true,
        "id": 14
    },

    {
        "title": "Hafenfreuden",
        // "sml_desc": "Die häfen von Tel Aviv",
        // "desc": "Die verschiedenen Reize von \nTel Aviv und Jaffa Häfen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/3.jpg",
        "img_mob":"/PostCarousel/video_mob/3.jpg",
        "side_img": "/PostCarousel/3.jpg",
        "read_more": "Weiterlesen",
        "vidId": "iHqD5eHDZm8",
        "link": "/Posts/index.php?post=3",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 3
    },

    {
        "title": "Machne Yehuda-Markt",
        // "sml_desc": "Ein Fest für alle Sinne",
        // "desc": "Lassen Sie sich die erstaunlichen visuellen \nEindrücke und die Geräuschkulisse des Marktes",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/b.jpg",
        "img_mob":"/Videos/video_mob/b.jpg",
        "side_img": "Videos/sidebar/b.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=7",
        "vidId": "2CSCe2WC7Ns",
        "ctg": "culinary",
        "isVid": true,
        "forVidPage": true,
        "id": 12
    },

    {
        "title": "DAS TOTE MEER",
        // "sml_desc": "Zeit für eine Auszeit in\nder glorreichen Natur",
        // "desc": "Höchster Genuss am \ntiefstgelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/100.jpg",
        "img_mob":"/PostCarousel/video_mob/100.jpg",
        "side_img": "/PostCarousel/100.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=2",
        "vidId": "ixFocykfYHo",
        "css_class": "unic_video-post-3",
        "isVid": true,
        "forVidPage": true,
        id: 3,
        ctg: "deadsea"
    },
    {
        "title": "EIN KULINARISCHER URLAUB IN GALILÄA",
        // "sml_desc": "Ein Paradies für Foodies",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/culinary-in-galilee.jpg",
        "side_img": "PostCarousel/culinary-in-galilee.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Culinary_In_Galilee",
        "ctg": "culinarynorth",
        "isVid": false,
        "id": "Culinary_In_Galilee"
    },


    {
        "title": "Sarona Tel Aviv",
        // "desc": "Eine riesige Auswahl von Attraktionen in \n der überwältigenden sanierten Templerkolonie",
        // "sml_desc": "Eine atemberaubende urbane Oase",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=1",
        "vidId": "7JF0z2XPpz0",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 7
    },

    {
        "title": "Die Altstadt",
        // "sml_desc": "Spüre, wie die Geschichte \n zum Leben erwacht",
        // "desc": "Lassen Sie sich von den weltberühmten Schätzen \n des historischen Jerusalem inspirieren",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/m.jpg",
        "img_mob":"/Videos/video_mob/m.jpg",
        "side_img": "Videos/sidebar/m.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=4",
        "vidId": "1byfX1O7u4g",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": 13
    },

    {
        "title": "Neve Tzedek",
        // "sml_desc": "Schick und einzigartig",
        // "desc": "Liebenswerte Cafés, Boutiquen, Kunstgalerien, \n Eleganz und coole Vibes",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/j.jpg",
        "img_mob":"/Videos/video_mob/j.jpg",
        "side_img": "Videos/sidebar/j.jpg",
        "read_more": "Weiterlesen",
        "vidId": "-ESCEVfOreY",
        "link": "/Posts/index.php?postType=video&post=7",
        "css_class": "unic_video-post-13",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 8
    },


    
    


    {
        "title": "Tel Aviv Am Srand",
        // "sml_desc": "Weil sich das Leben in Tel Aviv \n von der Sonnenseite zeigt",
        // "desc": "Bereit für eine volle \nLadung Spaß in der Sonne?",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob": "Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        "vidId": "ExuWHatIrKE",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": 4
    },

    

    //No translation 
    // {
    //     "title": "ULTIMATE BEACH FUN",
    //     "sml_desc": "",
    //     "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    //     "img": "/PostCarousel/101.jpg",
    //     "side_img": "/PostCarousel/101.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=24",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": true,
    //     id: 24,
    //     "ctg": "telaviv",
    //     "showOnHome": false,
    // },








    

    
    // culinary 
    
    
    {
        "title": "FEINSCHMECKERSZENE TEL AVIV",
        "sml_desc": "",
        // "sml_desc": "Dem köstlichen Frühstück in Tel Aviv kann auch Jamie Oliver nicht widerstehen.",
        "desc": "",
        "img": "Videos/JamieOliver.jpg",
         "img_mob":"/Videos/video_mob/JamieOliver.jpg",
        "side_img": "Videos/sidebar/JamieOliver.jpg",
        "vidId": "gGe4W8WaIiQ",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=86",
        "ctg": "culinary",
        "isVid": true,
        "forVidPage": true,
        "id": 86
    },

    {
        "title": "Die Vegane Szene In Tel Aviv",
        // "sml_desc": " Genieße die riesige Auswahl veganer Köstlichkeiten - \n vegane Eiscreme inklusive!",
        "sml_desc": " ",
        // "desc": "Gewählt als bestes Reiseziel \n  für Veganer weltweit",
        "desc": "",
        "img": "Videos/h.jpg",
        "img_mob":"/Videos/video_mob/h.jpg",
        "side_img": "Videos/sidebar/h.jpg",
        "vidId": "tNl2QXNOHMk",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=6",
        "ctg": "culinary",
        "isVid": true,
        "forVidPage": true,
        "id": 5
    },

    {
        "title": "Jerusalem",
        // "sml_desc": "Kulinarische Highlights in Jerusalem",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/37.jpg",
        "img_mob":"/PostCarousel/video_mob/37.jpg",
        "side_img": "/PostCarousel/37.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=38",
        "ctg": "culinary",
        "vidId": "2CSCe2WC7Ns",
        "isVid": true,
        "forVidPage": true,
        "id": 15
    },




    {
        "title": "Ein Feinschmeckerparadies",
        // "sml_desc": " Komm heraus in Tel Avivs \n genialer kulinarischer Szene",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/99.jpg",
        "img_mob":"/PostCarousel/video_mob/99.jpg",
        "side_img": "/PostCarousel/99.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=21",
        "ctg": "culinary",
        "vidId": "n4kCnPXEX7g",
        "isVid": true,
        "forVidPage": true,
        "id": 21
    },



    {
        "title": "Küche in Jerusalem",
        // "sml_desc": "Küche in Jerusalem",
        // "desc": "Aufregend, vielfältig und \nach so lecker",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/13.jpg",
        "img_mob":"/PostCarousel/video_mob/13.jpg",
        "side_img": "/PostCarousel/13.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=13",
        "ctg": "culinary",
        "vidId": "2CSCe2WC7Ns",
        "isVid": true,
        "forVidPage": true,
        "id": 13
    },

    
    // NO TRANSLATION
    // {
    //     "title": "Kaffee in Tel Aviv",
    //     "sml_desc": "Tel Aviv over a fresh coffee",
    //     "desc": "Coffee shop culture is fundamental",
    //     "img": "Videos/coffee.jpg",
    //     "side_img": "Videos/sidebar/coffee.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?postType=video&post=16",
    //     "vidId": "rVr0gqFC364",
    //     "ctg": "culinary",
    //     "isVid": true,
    //     "id": 10
    // },

   

    {
        "title": "Feinschmeckerszene Tel Aviv",
        // "sml_desc": "Der perfekte Ort, an dem Sie die bunte Vielfalt der hochkarätigen Restaurants von Tel Aviv genießen können",
        "sml_desc": "",
        // "desc": "Verwöhnen Sie Ihren Gaumen in Tel Aviv",
        "desc": "",
        "img": "Videos/e.jpg",
        "img_mob":"/Videos/video_mob/e.jpg",
        "side_img": "Videos/sidebar/e.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=33",
        "vidId": "jfyHxk8ZRrI",
        "ctg": "culinary",
        "isVid": true,
        "forVidPage": true,
        "id": 11
    },

     {
        "title": "Susshuka Zeit",
        // "sml_desc": "Susshuka Zeit",
        "sml_desc": "",
        // "desc": "Lerne Sie, wie man das weltberühmte\n Shakshuka-Gericht zubereitet!",
        "desc": "",
        "img": "/PostCarousel/22.jpg",
        "img_mob":"/PostCarousel/video_mob/22.jpg",
        "side_img": "/PostCarousel/22.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=22",
        "ctg": "culinary",
        "vidId" : 'n4kCnPXEX7g',
        "isVid": true,
        "forVidPage": true,
        "id": 22
    },


    //  non videos

    {
        "title": "Die Stra Die Strande Von Tel Aviv",
        // "sml_desc": "Entspannen Sie Sich An Den\n Sonnigen Stranden Von Tel Aviv",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/14.jpg",
        "side_img": "/PostCarousel/14.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=14",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": 14
    },

    
    {
        "title": "Jerusalem- Stadt der Überraschungen",
        // "sml_desc": "Eine Stadt, die alle Erwartungen übertrifft",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/38.jpg",
        "side_img": "/PostCarousel/38.jpg",
        "read_more": "Weiterlesen",
        "link": this.url + "/Posts/index.php?post=30",
        "ctg": "jerusalem",
        "isVid": false,
        "id": 38
    },




    
    {
        "title": "DAS TOTE MEER",
        // "sml_desc": "Zeit für eine Auszeit in \n der glorreichen Natur",
        // "desc": "Höchster Genuss am tiefstgelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/34.jpg",
        "side_img": "Videos/sidebar/34.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=15",
        "vidId": "ixFocykfYHo",
        "css_class": "unic_video-post-10",
        "isVid": false,
        id: 34,
        ctg: "deadsea"
    },



    
    {
        "title": "Ein Tag in Tel Aviv",
        // "sml_desc": "Vom Hafen zum Hafen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/35.jpg",
        "side_img": "/PostCarousel/35.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=36",
        "ctg": "telaviv",
        "isVid": false,
        "id": 36
    },
    
    //No translation
    // {
    //     "title": "First Time in Jerusalem",
    //     "sml_desc": "The must list for the first time visitor",
    //     "desc": "",
    //     "img": "/PostCarousel/43.jpg",
    //     "side_img": "/PostCarousel/43.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=43",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": 43
    // },


  


    {
        "title": "Tel Aviv",
        // "sml_desc": "Die ultimative Luxus-Destination",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/36.jpg",
        "side_img": "/PostCarousel/36.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=37",
        "ctg": "telaviv",
        "isVid": false,
        "id": 37
    },

    // No translation
    // {
    //     "title": "UNFORGETTABLE YAD VASHEM",
    //     "sml_desc": "",
    //     "img": "thingsToDo/10.jpg",
    //     "side_img": "thingsToDo/sidebar/10.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 31,
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },

    {
        "title": "Tourist info",
        // "sml_desc": "Alles was Sie wissen sollten",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/touristinfo.jpg",
        "side_img": "/PostCarousel/touristinfo.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Tourist_info",
        "isVid": false,
        "ctg": "telaviv",
        "id": "Tourist_info"
    },
    
    {
        "title": "Tel Aviv",
        // "sml_desc": "Mit dem Fahrrad in Tel Aviv",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=38",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": false,
        "id": 39
    },
    
    //No translation
    // {
    //     "title": "TOWER OF DAVID MUSEUM",
    //     "sml_desc": "",
    //     "img": "thingsToDo/7.jpg",
    //     "side_img": "thingsToDo/sidebar/7.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 29,
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },

    // No translation
    // {
    //     "title": "Upscale Jerusalem",
    //     "sml_desc": "Modern luxuries for the pampered traveler",
    //     "desc": "",
    //     "img": "/PostCarousel/45.jpg",
    //     "side_img": "/PostCarousel/45.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=45",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": 45
    // },

    {
        "title": "Tel Aviv Adventures",
        // "sml_desc": "Tel Aviv ist cool, Tel Aviv ist anders",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/40.jpg",
        "side_img": "/PostCarousel/40.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=40",
        "ctg": "telaviv",
        "isVid": false,
        "id": 40
    },

   {
        "title": "Die Museen Von Yel Aviv",
        // "sml_desc": "Zeit Fur Kultur",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/10.jpg",
        "side_img": "/PostCarousel/10.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=10",
        "isVid": false,
        "ctg": "telaviv",
        "id": 10
    },


    
     {
        "title": "Absolutes Muss in Tel Aviv",
        // "sml_desc": "Top 5 Stätten, die Sie in der Nonstop-Stadt nicht verpassen wollen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/17.jpg",
        "side_img": "/PostCarousel/17.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=17",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "id": 17
    },



    {
        "title": "Absolutes \'Muss\' in Jerusalem",
        // "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=18",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": 18
    },
     
    //   No Translation
    // {
    //     "title": "Nonstop-Aufregung",
    //     "sml_desc": "Schönes, buntes und \n unvergessliches Tel Aviv",
    //     "desc": "",
    //     "img": "/PostCarousel/2.jpg",
    //     "side_img": "/PostCarousel/2.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=2",
    //     "ctg": "telaviv",
    //     "isVid": false,
    //     "id": 2
    // },

    {
        "title": "Modern und lebendig",
        // "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/19.jpg",
        "side_img": "/PostCarousel/19.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=19",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": 19
    },

    {
        "title": "Einkaufsfreuden",
        // "sml_desc": "Von Couture bis zu Souvenirs, Jerusalem hat alles",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=5",
        "ctg": "jerusalem",
        "isVid": false,
        "forVidPage": true,
        "id": 5
     },
    
    // No TRanslation
    //  {
    //     "title": "Jerusalem’s Calling",
    //     "sml_desc": "The most radiant city on Earth",
    //     "desc": "",
    //     "img": "/PostCarousel/4.jpg",
    //     "side_img": "/PostCarousel/4.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=4",
    //     "ctg": "jerusalem",
    //     "isVid": false,
    //     "id": 13
    // },
    {
        "title": "Das Spirituelle Jerusalem",
        // "sml_desc": "Die Wichtigsten Sehenswurdigkeiten In Jerusalem",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/9.jpg",
        "side_img": "/PostCarousel/9.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=9",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": 99
    },

    {
        "title": "Mit Kindern reisen",
        // "sml_desc": "Ununterbrochene Spannung\n für die ganze Familie",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/33.jpg",
        "side_img": "/PostCarousel/33.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=25",
        "isVid": false,
        "ctg": "telavivAndJerusalem",
        "id": 41
    },

    //No translation
    // {
    //     "title": "WESTERN WALL WONDERS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/4.jpg",
    //     "side_img": "thingsToDo/sidebar/4.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 27,
    //     "ctg": "jerusalem",
    //     "showOnHome": false,

    // },


    //No translation
    // {
    //     "title": "WHITE CITY SPLENDOR",
    //     "sml_desc": "",
    //     "img": "thingsToDo/6.jpg",
    //     "side_img": "thingsToDo/sidebar/6.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 28,
    //     "showOnHome": false,
    //     "ctg": "telaviv"

    // },


    //No translation
    // {
    //     "title": "ALL SENSORY MARKETS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/8.jpg",
    //     "side_img": "thingsToDo/sidebar/8.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 30,
    //     "showOnHome": false,
    //     "ctg": "telavivAndJerusalem"

    // },
    

    //No translation
    //  {
    //     "title": "Go To Guide",
    //     "sml_desc": "Travel from Tel Aviv and Jerusalem",
    //     "desc": "",
    //     "img": "/PostCarousel/34.jpg",
    //     "side_img": "/PostCarousel/34.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=35",
    //     "ctg": "telavivAndJerusalem",
    //     "isVid": false,
    //     "id": 35
    // },
    
    {
        "title": "DIE WÜSTE NEGEV",
        // "sml_desc": "ein zauberhafter Ort",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/16.jpg",
        "side_img": "/PostCarousel/16.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=16",
        "isVid": false,
        "forVidPage": true,
        "ctg": "eilat",
        "id": "Die_Wuste_Negev"
    },
    
    // No translate
    // {
    //     "title": "TRAVELLING ON A BUDGET",
    //     "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
    //     "desc": "",
    //     "img": "/PostCarousel/44.jpg",
    //     "side_img": "/PostCarousel/44.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=44",
    //     "isVid": false,
    //     "ctg": "telavivAndJerusalem",
    //     "id": 44
    // },


    // {
    //     "title": "Die HÄFEN von Tel Aviv",
    //     // "sml_desc": "Der Hafen Von Tel Aviv \n And Der Haven Von Jaffa",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/1.jpg",
    //     "side_img": "/PostCarousel/1.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=1",
    //     "ctg": "telavivAndJerusalem",
    //     "isVid": false,
    //     "id": 1
    // },

    // No translate
    // {
    //     "title": "Party Capital",
    //     "sml_desc": "Epic Nights in the non stop city",
    //     "desc": "",
    //     "img": "/PostCarousel/42.jpg",
    //     "side_img": "/PostCarousel/42.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=42",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": 42
    // },
    

    // No needed
    // {
    //     "title": "Eurovision",
    //     "sml_desc": "The opportunity to visit Tel Aviv ",
    //     "desc": "As it hosts the Eurovision song contest",
    //     "img": "/PostCarousel/eurovision.jpg",
    //     "side_img": "/PostCarousel/eurovision.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=eurovision",
    //     "isVid": false,
    //     "ctg": "eurovision",
    //     "id": "eurovision"
    // },
    

    // No needed
    // {
    //     "title": "Get ready to party",
    //     "sml_desc": "The best Eurovision parties to be at",
    //     "desc": "",
    //     "img": "/PostCarousel/getreadytoparty.jpg",
    //     "side_img": "/PostCarousel/getreadytoparty.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=Get_ready_to_party",
    //     "isVid": false,
    //     "ctg": "eurovision",
    //     "id": "Get_ready_to_party"
    // },
    

    // No needed
    // {
    //     "title": "White night",
    //     "sml_desc": "White Night Lights Up",
    //     "desc": "Tel Aviv on 16th May",
    //     "img": "/PostCarousel/whitenight.jpg",
    //     "side_img": "/PostCarousel/whitenight.jpg",
    //     "read_more": "Weiterlesen",
    //     "link": "/Posts/index.php?post=White_night",
    //     "isVid": false,
    //     "ctg": "eurovision",
    //     "id": "White_night"
    // },


    //GO POSTS
    {
        "title": "DIE WEIHRAUCHSTRAßE",
        // "sml_desc": "Eine 2.000 Jahre alte Geschichte des Erfolgs",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/the-incense-road.jpg",
        "side_img": "/PostCarousel/the-incense-road.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Incense_Road",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "The_Incense_Road"
    },
    {
        "title": "DIE NEGEV WÜSTE",
        // "sml_desc": "DIE NEGEV WÜSTE – NICHT VERPASSEN",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/the-negev-desert.jpg",
        "side_img": "/PostCarousel/the-negev-desert.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Negev_Desert",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "The_Negev_Desert"
    },
    {
        "title": "ERKUNDEN SIE MASADA",
        // "sml_desc": "Mythos im Herzen der Judäischen Wüste",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/masada.jpg",
        "side_img": "/PostCarousel/masada.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Masada",
        "ctg": "eilat-negev",
        "isVid": false,
        "forVidPage": true,
        "id": "Masada"
    },

    {
        "title": "ENTDECKEN SIE DIE VERBORGENEN JUWELEN VON GALILÄA",
        // "sml_desc": "Ihr Traumurlaub in Israel voller Überraschungen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/hidden-galilee.jpg",
        "side_img": "/PostCarousel/hidden-galilee.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Hidden_Galilee",
        "ctg": "north",
        "isVid": false,
        "id": "Hidden_Galilee"
    },

    {
        "title": "NAZARETH",
        // "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
        "sml_desc":   "",
        "desc": "",
        "img": "/PostCarousel/nazareth.jpg",
        "side_img": "/PostCarousel/nazareth.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Nazareth",
        "ctg": "north",
        "isVid": false,
        "forVidPage": true,
        "id": "Nazareth"
    },

    

    {
        "title": "ROSH PINA",
        // "sml_desc": "Pastoraler Geheimtipp für Touristen in Galiläa",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/rosh-pina.jpg",
        "side_img": "PostCarousel/rosh-pina.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Rosh_Pina",
        "ctg": "north",
        "isVid": false,
        "id": "Rosh_Pina"
    },

    

    
    {
        "title": "EIN MAGISCHER ORT",
        // "sml_desc": "DIE NEGEV-WÜSTE ",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/a-magic-place.jpg",
        "side_img": "PostCarousel/a-magic-place.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=A_Magic_Place",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "A_Magic_Place"
    },
    {
        "title": "DIE ARAVA: ÜBERRASCHE DICH SELBST!",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/the-arava.jpg",
        "side_img": "PostCarousel/the-arava.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Arava",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "The_Arava"
    },
    {
        "title": "ACTION-SPAß IN DER WÜSTE ISRAELS",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/action-fun.jpg",
        "side_img": "PostCarousel/action-fun.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Action_Fun_In_Desert",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "Action_Fun_In_Desert"
    },
    {
        "title": "SENSATIONELL - EIN ENDLOS LANGER SOMMER",
        // "sml_desc": "Eilat",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/sensational.jpg",
        "side_img": "PostCarousel/sensational.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Eilat_Sensational",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "Eilat_Sensational"
    },

    {
        "title": "JERUSALEM ENTDECKEN",
        // "sml_desc": "Entdecken Sie die Geheimnisse des jüdischen Jerusalem in der geschichtsträchtigen Altstadt",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/discover-jerusalem.jpg",
        "side_img": "PostCarousel/discover-jerusalem.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Discover_Jerusalem",
        "ctg": "jerusalem",
        "isVid": false,
        "forVidPage": true,
        "id": "Discover_Jerusalem"
    },

    {
        "title": "WAGEN SIE EINEN SPRUNG",
        // "sml_desc": "Erleben Sie die Wasserattraktionen in Eilat",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/atractions-in-eilat.jpg",
        "side_img": "PostCarousel/atractions-in-eilat.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Atractions_In_Eilat",
        "ctg": "eilat-negev",
        "isVid": false,
        "forVidPage": true,
        "id": "Atractions_In_Eilat"
    },

    {
        "title": "DAS DOLPHIN REEF EILAT",
        // "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/the-dolphin-reef.jpg",
        "side_img": "PostCarousel/the-dolphin-reef.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Dolphin_Reef",
        "ctg": "eilat-negev",
        "isVid": false,
        "forVidPage": true,
        "id": "The_Dolphin_Reef"
    },
    {
        "title": "ABENTEUER DURCH DIE ZEIT",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/jeru-salem.jpg",
        "side_img": "PostCarousel/jeru-salem.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Jerusalem_",
        "ctg": "jerusalem",
        "isVid": false,
        "id": "Jerusalem_"
    },
    {
        "title": "HAIFA BERAUSCHENDE SCHÖNHEIT",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/haifa-intoxicating-beauty.jpg",
        "side_img": "/PostCarousel/haifa-intoxicating-beauty.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Haifa_Intoxicating_Beauty",
        "ctg": "north",
        "isVid": false,
        "forVidPage": true,
        "id": "Haifa_Intoxicating_Beauty"
    },

    {
        "title": "The Hula Valley Natural",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/the-hula-valley-natural.jpg",
        "side_img": "/PostCarousel/the-hula-valley-natural.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Hula_Valley_Natural",
        "ctg": "north",
        "isVid": false,
        "forVidPage": true,
        "id": "The_Hula_Valley_Natural"
    },

    {
        "title": "Fühlen Sie sich pudelwohl",
        // "sml_desc": "am tiefstgelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/feel-pudelwohl.jpg",
        "side_img": "/PostCarousel/feel-pudelwohl.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Feel_Pudelwohl",
        "ctg": "deadsea",
        "isVid": false,
        "id": "Feel_Pudelwohl"
    },

    {
        "title": "DAS TOTE MEER",
        // "sml_desc": "Aufschwung für Geist und Seele am tiefst gelegenen Ort der Erde",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/aufschwung-fur-geist.jpg",
        "side_img": "/PostCarousel/aufschwung-fur-geist.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Aufschwung_Fur_Geist",
        "ctg": "deadsea_2",
        "isVid": false,
        "forVidPage": true,
        "id": "Aufschwung_Fur_Geist"
    },

    {
        "title": "TEL AVIV & JERUSALEM",
        // "sml_desc": "Impuls und Inspiration ergänzen sich zu DEM perfekten Reisepaket",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/telaviv-and-jerusalem.jpg",
        "side_img": "/PostCarousel/telaviv-and-jerusalem.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=TelAviv_And_Jerusalem",
        "ctg": "telavivAndJerusalem",
        "isVid": false,
        "id": "TelAviv_And_Jerusalem"
    },
  
    {
        "title": "CAESAREA EINE ZEITREISE",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/caesarea-time-travel.jpg",
        "side_img": "/PostCarousel/caesarea-time-travel.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Caesarea_A_Time_Travel",
        "ctg": "north",
        "isVid": false,
        "id": "Caesarea_A_Time_Travel"
    },
    
    {
        "title": "ISRAELS MAJESTÄTISCHE WÜSTE",
        // "sml_desc": "Wo Abenteuer und Inspiration Sie erwarten",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/majestic-desert.jpg",
        "side_img": "/PostCarousel/majestic-desert.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Majestic_Desert",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "Majestic_Desert"
    },
   

    {
        "title": "EINZIGARTIGES KAUFERLEBNIS IN ISRAEL",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/shoping-in-israel.jpg",
        "side_img": "/PostCarousel/shoping-in-israel.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Shoping_In_Israel",
        "ctg": "jerusalem",
        "isVid": false,
        "id": "Shoping_In_Israel"
    },
    {
        "title": "TIMNA PARK",
        // "sml_desc": "Ein begeisterndes Wüstenabenteuer",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/park-timna.jpg",
        "side_img": "/PostCarousel/park-timna.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Park_Timna",
        "ctg": "eilat-negev",
        "isVid": false,
        "forVidPage": true,
        "id": "Park_Timna"
    },
    

    
    
    {
        "title": "ÜBERNACHTEN IN DER NEGEV WÜSTE",
        // "sml_desc": "",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/stay-in-negev.jpg",
        "side_img": "/PostCarousel/stay-in-negev.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Stay_In_THe_Negev",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "Stay_In_THe_Negev"
    },
    {
        "title": "DER NEGEV",
        // "sml_desc": "er perfekte Ort für Ihr persönliches Wüstenabenteuer",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/desert-adventure.jpg",
        "side_img": "/PostCarousel/desert-adventure.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Desert_Adventure",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "Desert_Adventure"
    },
    {
        "title": "AKTIVURLAUB IN GALILÄA",
        // "sml_desc": "Aktiv Abenteuer erleben in Galiläa",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/adventures-in-galilea.jpg",
        "side_img": "/PostCarousel/adventures-in-galilea.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Adventures_In_Galilea",
        "ctg": "north",
        "isVid": false,
        "id": "Adventures_In_Galilea"
    },

    {
        "title": "WAS MACHT EILAT ZUM ULTIMATIVEN URLAUBSZIEL?",
        // "sml_desc": "Erkunden Sie die Stadt des ewigen Sonnenscheins",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/eilat1.jpg",
        "side_img": "/PostCarousel/eilat1.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Eilat_",
        "ctg": "eilat-negev",
        "isVid": false,
        "id": "Eilat_"
    },
    {
        "title": "SAFED",
        // "sml_desc": "wo Mystik und Weltliches aufeinandertreffen",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/mystic-and-worldly-meeting.jpg",
        "side_img": "/PostCarousel/mystic-and-worldly-meeting.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Mystic_And_Worldly_Meeting",
        "ctg": "north",
        "isVid": false,
        "forVidPage": true,
        "id": "Mystic_And_Worldly_Meeting"
    },
    {
        "title": "NAZARETH: EIN JUWEL MIT VIELEN FACETTEN",
        // "sml_desc": "Das historische Zentrum mit aufregenden modernen Seiten",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/nazareth-the-historical-center.jpg",
        "side_img": "/PostCarousel/nazareth-the-historical-center.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Nazareth_The_Historical_Center",
        "ctg": "north",
        "isVid": false,
        "id": "Nazareth_The_Historical_Center"
    },
    

    // THESE TWO posts complite the missing posts for carousel TEL AVIV
    {
        "title": "Sarona Tel Aviv",
        // "desc": "Eine riesige Auswahl von Attraktionen in \n der überwältigenden sanierten Templerkolonie",
        // "sml_desc": "Eine atemberaubende urbane Oase",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=1",
        "vidId": "7JF0z2XPpz0",
        "ctg": "telaviv",
        "isVid": true,
        "isDouble":true,
        "forVidPage": true,
        "id": 7
    },
    {
        "title": "Tel Aviv Am Srand",
        // "sml_desc": "Weil sich das Leben in Tel Aviv \n von der Sonnenseite zeigt",
        // "desc": "Bereit für eine volle \nLadung Spaß in der Sonne?",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob": "Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        "vidId": "ExuWHatIrKE",
        "ctg": "telaviv",
        "isVid": true,
        "isDouble":true,
        "forVidPage": true,
        "id": 4
    },

    // End THESE TWO posts complite the missing posts for carousel TEL AVIV

    // End This post complite the missing posts for carousel JERUSALEM
    {
        "title": "Absolutes \'Muss\' in Jerusalem",
        // "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=18",
        "vidId":"k4OwoEk5wMw",
        "isVid": true,
        "forVidPage": true,
        "isDouble": true,
        "ctg": "jerusalem",
        "id": 18
    },
    // End This post complite the missing posts for carousel JERUSALEM

    // End THESE TWO posts complite the missing posts for carousel NEGEV AND EILAT
    {
        "title": "DAS DOLPHIN REEF EILAT",
        // "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/the-dolphin-reef.jpg",
        "side_img": "PostCarousel/the-dolphin-reef.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=The_Dolphin_Reef",
        "ctg": "eilat-negev",
        "isVid": false,
        "forVidPage": true,
        "isDouble": true,
        "id": "The_Dolphin_Reef"
    },
    {
        "title": "TIMNA PARK",
        // "sml_desc": "Ein begeisterndes Wüstenabenteuer",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/park-timna.jpg",
        "side_img": "/PostCarousel/park-timna.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Park_Timna",
        "ctg": "eilat-negev",
        "isVid": false,
        "forVidPage": true,
        "isDouble": true,
        "id": "Park_Timna"
    },
    // End THESE TWO posts complite the missing posts for carousel NEGEV AND EILAT

    // End THESE TWO posts complite the missing posts for carousel NORTH
    {
        "title": "NAZARETH",
        // "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
        "sml_desc":   "",
        "desc": "",
        "img": "/PostCarousel/nazareth.jpg",
        "side_img": "/PostCarousel/nazareth.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Nazareth",
        "ctg": "north",
        "isVid": false,
        "forVidPage": true,
        "isDouble": true,
        "id": "Nazareth"
    },
    {
        "title": "ROSH PINA",
        // "sml_desc": "Pastoraler Geheimtipp für Touristen in Galiläa",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/rosh-pina.jpg",
        "side_img": "PostCarousel/rosh-pina.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Rosh_Pina",
        "ctg": "north",
        "isVid": false,
        "isDouble": true,
        "id": "Rosh_Pina"
    },
    // End THESE TWO posts complite the missing posts for carousel NORTH


]



export const Reminders = [

       // Tel Aviv
      {
        "quote": "One of the world's 25 best cities for foodies",
        "site": "Business Insider",
        "img": "/References/1.jpg",
        "ctg": "Tel Aviv",

       
      },

      // Jerusalem
      {
        "quote": "TripAdvisor Traveler's Choice Award 2015",
        "site": "TripAdvisor",
        "img": "/References/9.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's leading party cities",
        "site": "Telegraph",
        "img": "/References/2.jpg",
        "ctg": "Tel Aviv",
       
      },
      

      {
        "quote": "One of the cities with most beautiful people",
        "site": "Conde Nast",
        "img": "/References/3.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "One of the 20 must visit destinations in the world  TNS",
        "site": "The National Student",
        "img": "/References/10.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the best beach party spots on the planet",
        "site": "USA Today",
        "img": "/References/4.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top 10 beach cities",
        "site": "National Geographic",
        "img": "/References/5.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "3rd Of 6 Top world’s holiest sites",
        "site": "National Geographic",
        "img": "/References/11.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's top ten cities",
        "site": "Lonely Planet",
        "img": "/References/6.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top ten hedonistic city breaks ",
        "site": "Lonely Planet",
        "img": "/References/7.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "I just thought it was magical… It instantly turned into my favorite trip.",
        "site": "TripAdvisor",
        "img": "/References/12.jpg",
        "ctg": "Jerusalem",
        "job" : "CEO, Stephen Kaufer about Jerusalem" ,
        "cssClass" : "make-it-smller"
      },

      {
        "quote": "The World’s New Dining Hotspot",
        "site": "Bloomberg.com",
        "img": "/References/8.jpg",
        "ctg": "Tel Aviv",
       
      },

      

]







// WEBPACK FOOTER //
// ./src/Data/Data.js